export const DATE_INPUT_ERRORS = [
	'INVALID_DATE_FORMAT',
	'INVALID_MONTH',
	'INVALID_DAY_NUMBER',
	'INVALID_DAY_OF_MONTH',
	'DATETIME_INVALID_FORMAT',
];
export const TIME_INPUT_ERRORS = [
	'TIME_FORMAT_INVALID',
	'INVALID_HOUR',
	'INVALID_MINUTES',
	'INVALID_SECONDS',
	'INVALID_TIME_EMPTY',
];
